<template lang="pug">
  content-page
    div(slot="nav")
      navigation-default
    div.hidden-sm-and-down(slot="sidebar")
      ad(location="sidebar").mb-6
      offers.mb-6
    .flow-left
      nuxt-child
</template>

<script>
import NavigationDefault from '@/components/navigation-default';

export default {
	components: { NavigationDefault },
	scrollToTop: true,
	nuxtI18n: {
		paths: {
			'nl-NL': '/*',
			'de-DE': '/*',
			'nl-BE': '/*'
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
